import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityHoliday } from "../../entity/EntityHoliday";

export class DtoHolidaysPostReq extends EntityHoliday {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
